import { Button } from '@/components/ui/Button';
import { Link, useNavigate } from 'react-router-dom';
import { useDaoConfig } from '@/hooks/useDaoConfig';

/**
 * Registration Role Selection Page
 *
 * Dynamic role selector displaying cards for the active DAO's worker and client personas.
 */
export default function RegisterPage() {
  const navigate = useNavigate();
  const { workerRole, clientRole, workerPitch, clientPitch } = useDaoConfig();

  return (
    <div className="onboardingContent">
      {/* Top right button to Login */}
      <div className="loginBtn">
        <span>Already have an account?</span>
        <Button variant="secondary" onClick={() => navigate('/login')}>
          Log In
        </Button>
      </div>

      <h1 className="mb-2 text-left text-3xl font-bold text-[--text-dark-primary]">
        What kind of account do you want to create?
      </h1>

      <div className="space-y-[--spacing-8]">
        {/* Worker Card */}
        <Link to="/register/developer" className="roleCard group block">
          {/* Custom Checkbox Indicator */}
          <div className="roleCard__checkbox group-hover:bg-[--state-brand-active]">
            <i className="ri-check-line innerIcon group-hover:opacity-100" />
          </div>

          <div className="roleCard__info">
            <span className="title">{workerRole}</span>
            <p className="description">{workerPitch}</p>
          </div>
        </Link>

        {/* Client Card */}
        <Link to="/register/client" className="roleCard group block">
          {/* Custom Checkbox Indicator */}
          <div className="roleCard__checkbox group-hover:bg-[--state-brand-active]">
            <i className="ri-check-line innerIcon group-hover:opacity-100" />
          </div>

          <div className="roleCard__info">
            <span className="title">{clientRole}</span>
            <p className="description">{clientPitch}</p>
          </div>
        </Link>
      </div>
    </div>
  );
}
